<template>
  <div>
    <PermissionValidation
      :marketId="marketId"
      rule="enableViewAppeal"
    >
      <approve-list-appeal
        :loading="isMainLoading"
        @onInit="getApproveTasksByMarket"
        :approveTasks="approveTasks"
      ></approve-list-appeal>
    </PermissionValidation>
  </div>
</template>

<script>
import ApproveListAppeal from "../../components/ApproveListAppeal.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    ApproveListAppeal,
    PermissionValidation
  },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    approveTasks() {
      return this.$store.getters["approveTask/getByType"]("appeal");
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId
    };
  },
  methods: {
    getApproveTasksByMarket() {
      this.$emit("onGetApproveTasksByMarket");
    }
  }
};
</script>